import $ from "jquery";
import "jquery-mask-plugin";
import { Fancybox } from "@fancyapps/ui";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

import "../css/main.css";

// Expor Swiper globalmente para scripts inline
window.Swiper = Swiper;
window.SwiperModules = { Navigation };

// import { initBestSellerTemplate } from "./countProductCart.js";
// import { menuCategories } from "./categoriesMenuWoocommerce.js";
import { cartCustomCheckout } from "./cart-custom-checkout.js";
import { registerCheckout } from "./checkoutRegister.js";
import { checkoutAuth } from "./checkoutAuth.js";
import "./checkout-auth.js";
import "./checkout-cart.js";
import { changePointerEventsHeaderMobile } from "./changePointerEventsHeaderMobile..js";
import { toggleSearch } from "./toggleSearch.js";
import { changeItemFormSearch } from "./changeItemFormSearch.js";
import { toggleMiniCart } from "./toggleMiniCart.js";
import { initializeSwiper } from "./initializeSwiper.js";
import { changePointerEventsFooterMobile } from "./changePointerEventsFooterMobile..js";
import { initBlogSearch } from "./blogSearch.js";
import { initBlogPagination } from "./blogPagination.js";
import { initBlogCategories } from "./blogCategories.js";
import { validationContactForm } from "./validationContactForm.js";
import { checkoutFunctions } from "./checkoutFunctions.js";
import { changeStepsCheckout } from "./changeStepsCheckout.js";
import { initAjaxAddToCart, initCartBadge } from "./countProductCart.js";
import { initCartAjax } from "./cartPage.js";
import { addAddressCheckout } from "./addAddress.js";
import { changeAddressSelected } from "./changeAddressSelectedCheckout.js";
import "./faq-accordion.js";
import {
  calculateProductShipping,
  handleVariationRadioChange,
  handleQtyDecrease,
  initAccordion,
  handleQtyIncrease,
  syncRadiosWithSelect,
  reorderSections,
  handleVariableAddToCart,
} from "./single-product.js";
import { paymentCheckoutMethod } from "./paymentCheckout.js";
import { functionsFiltersProducts } from "./functionsFiltersProducts.js";
import { changeAccordionFAQ } from "./changeAccordionFAQ.js";
import { animations } from "./animations.js";
import { inputMasks } from "./inputMasks.js";
import { initFloatingDropdowns } from "./floatingDropdown.js";
import { initFloatingModals } from "./floatingModal.js";
import { initFloatingTooltips } from "./floatingTooltip.js";
import { initCartPage } from "./cart-page.js";
import { accountLogin, initPasswordVisibilityToggle } from "./accountLogin.js";
import { initDashboardAddress } from "./dashboardAddress.js";
import { toast } from "./toast.js";
import { initCepChecker } from "./cepChecker.js";
import "./card-produto.js";
import { initRemoveFromWishlist } from "./wishlist.js";
import { init404Page } from "./page-404.js";

// Disponibiliza o toast globalmente
window.Toast = toast;

// Não sobrescrever o jQuery global do WordPress para preservar plugins (ex.: datepicker)
// Mas exponha $ como atalho para window.jQuery (do WP) para compatibilidade com scripts do tema
window.$ = window.jQuery;

document.addEventListener("DOMContentLoaded", () => {
  changePointerEventsHeaderMobile();
  // initBestSellerTemplate();
  // menuCategories();
  cartCustomCheckout();
  registerCheckout();
  checkoutAuth();
  initializeSwiper();
  toggleSearch();
  changeAddressSelected();
  initBlogSearch();
  initBlogPagination();
  initBlogCategories();
  changeItemFormSearch();
  toggleMiniCart();
  changePointerEventsFooterMobile();
  validationContactForm();
  checkoutFunctions();
  changeStepsCheckout();
  initAjaxAddToCart();
  initCartBadge();
  addAddressCheckout();
  initCartAjax();
  handleVariationRadioChange();
  handleVariableAddToCart();
  calculateProductShipping();
  handleQtyDecrease();
  initAccordion();
  handleQtyIncrease();
  syncRadiosWithSelect();
  reorderSections();
  paymentCheckoutMethod();
  functionsFiltersProducts();
  changeAccordionFAQ();
  animations();
  inputMasks();
  initFloatingDropdowns();
  initFloatingModals();
  initFloatingTooltips();
  initCartPage();
  accountLogin();
  initPasswordVisibilityToggle();
  initDashboardAddress();
  initCepChecker();
  initRemoveFromWishlist();
  init404Page();
  Fancybox.bind("[data-fancybox]", {
    Hash: false,
    Youtube: {
      noCookie: true,
      rel: 0,
      showinfo: 0,
    },
  });
});
